import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable"
import { IconField } from "primereact/iconfield";
import { InputIcon } from "primereact/inputicon";
import { InputText } from "primereact/inputtext";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useGetPatientMutation } from "../hooks/useGetDataQuery";
import { FilterMatchMode } from "primereact/api";
import { Checkbox } from "primereact/checkbox";
import { Button } from "primereact/button";
import { formatNameAndSurname } from "../Utils/format";
import { de } from "date-fns/locale";

const OngoingPlanList = ({
    planList,
    planListCount,
    filterModes,
    setFilterModes,
    t,
    homePageMode,
    finishedPlansFilter,
    setFinishedPlansFilter,
    notStartedPlansFilter,
    setNotStartedPlansFilter,
    activeLast5DaysFilter,
    setActiveLast5DaysFilter
}: any) => {

    const {
        mutate: getPatient,
        data: patientData,
        isSuccess: isSuccessGetPatient,
    } = useGetPatientMutation();


    const lang = localStorage.getItem("i18nextLng") === "en" ? "en-US" : "tr-TR";
    const navigate = useNavigate();
    const [selectedRow, setSelectedRow] = useState<any>();

    const [filters, setFilters] = useState({
        global: { value: null, matchMode: FilterMatchMode.CONTAINS },
    });
    const [globalFilterValue, setGlobalFilterValue] = useState('');

    const columns = [
        {
            field: "patientFirstName",

        },
        {
            field: "planStatus",

        },
        {
            field: "planName",

        },
        {
            field: "planDateStart",

        },
        {
            field: "lastActivityDate",

        },
        {
            field: "overallSuccess",

        },
        {
            field: "adherancePercentage",

        },
        {
            field: "exercisesAdheranceList",

        },
    ];

    useEffect(() => {
        if (isSuccessGetPatient) {
            localStorage.setItem("patient", JSON.stringify({
                ...patientData.data,
                status: selectedRow.status,
                planName: selectedRow.planName,
                firstName: formatNameAndSurname(patientData.data.firstName),
                lastName: formatNameAndSurname(patientData.data.lastName),
            }));
            navigate({ pathname: "/mobithera/prescription" })
        }
    }, [isSuccessGetPatient]);

    const onGlobalFilterChange = (e: any) => {
        const value = e.target.value;
        let _filters = { ...filters };

        _filters['global'].value = value;

        setFilters(_filters);
        setGlobalFilterValue(value);
    };

    const header = () => {
        return (
            <>
                {homePageMode === 0 &&
                    <div className="flex justify-content-between align-items-center">
                        <p className='text-xl' style={{ color: "#727A99" }}>{t("allPlans")}
                        </p>
                        <IconField iconPosition="left" className='w-20rem' >
                            <InputIcon className="pi pi-search" />
                            <InputText value={globalFilterValue} onChange={onGlobalFilterChange} className='w-full' style={{ borderRadius: "10px" }} placeholder={t("searchByFirstOrLastName")} />
                        </IconField>
                    </div>}
                {homePageMode === 1 &&
                    <div className="flex justify-content-between align-items-center">
                        <div className="flex gap-4 justify-content-center align-items-center">
                            <p className='text-xl' style={{ color: "#727A99" }}>{t("allPlans")}
                            </p>
                            <IconField iconPosition="left" className='w-20rem' >
                                <InputIcon className="pi pi-search" />
                                <InputText value={globalFilterValue} onChange={onGlobalFilterChange} className='w-full' style={{ borderRadius: "10px" }} placeholder={t("searchByFirstOrLastName")} />
                            </IconField>
                        </div>

                        <div className="flex gap-2">
                            <Button
                                label={t('finishedPlans')}
                                onClick={() => setFinishedPlansFilter((prev: any) => !prev)}
                                style={{
                                    color: finishedPlansFilter ? "#FFFFFF" : "#2D3967",
                                    backgroundColor: finishedPlansFilter ? "#576185" : "#EAEBF0",
                                    height: '3rem',
                                    width: '12rem',
                                    borderRadius: "10px",
                                    border: "none",
                                }}
                            />

                            <Button
                                label={t('notStartedPlansFilter')}
                                onClick={() => setNotStartedPlansFilter((prev: any) => !prev)}
                                style={{
                                    color: notStartedPlansFilter ? "#FFFFFF" : "#2D3967",
                                    backgroundColor: notStartedPlansFilter ? "#576185" : "#EAEBF0",
                                    height: '3rem',
                                    width: '12rem',
                                    borderRadius: "10px",
                                    border: "none",
                                }}
                            />

                            <Button
                                label={t('activeLast5Days')}
                                onClick={() => setActiveLast5DaysFilter((prev: any) => !prev)}
                                style={{
                                    color: activeLast5DaysFilter ? "#FFFFFF" : "#2D3967",
                                    backgroundColor: activeLast5DaysFilter ? "#576185" : "#EAEBF0",
                                    height: '3rem',
                                    width: '12rem',
                                    borderRadius: "10px",
                                    border: "none",
                                }}
                            />
                        </div>


                    </div>}
            </>

        );
    };

    const nameBody = (rowData: any) => {
        return rowData.patientFirstName + " " + rowData.patientLastName
    }

    const complitionBody = (rowData: any) => {
        if (rowData.adherancePercentage) {
            return rowData.adherancePercentage + "%"
        }
        else {
            return "-"
        }
    }

    const planStartDateBody = (rowData: any) => {
        if (rowData.planDateStart) {
            const formattedDate = new Date(rowData.planDateStart).toLocaleDateString("tr-TR", {
                day: "2-digit",
                month: "2-digit",
                year: "numeric",
            });
            return formattedDate.replace(", ", " ")
        }
        else {
            return "-"
        };
    }

    const lastActivityDateBody = (rowData: any) => {
        if (rowData.lastActivityDate) {
            const formattedDate = new Date(rowData.lastActivityDate).toLocaleDateString("tr-TR", {
                day: "2-digit",
                month: "2-digit",
                year: "numeric",
            });
            return formattedDate.replace(", ", " ")
        }
        else {
            return "-"
        };
    }

    const exerciseDateBody = (rowData: any) => {
        if (rowData) {
            const date = new Date(rowData);
            const formatter = new Intl.DateTimeFormat(lang, {
                month: "short",
                day: "2-digit"
            });
            const [month, day] = formatter.format(date).split(" ");
            return `${month.toUpperCase()} ${day}`;
        }
        else {
            return "-"
        };
    }

    const overalSuccessBody = (rowData: any) => {
        return Math.round(rowData.overallSuccess) + "%"
    }

    const viewPatientDetails = (rowData: any) => {
        if(rowData){
            setSelectedRow(rowData)
            getPatient(rowData.patientId);
        }

    }

    const poligonStructure = (
        width: any,
        height: any,
        color: any,
        withBorder: any,
        borderColor: any,
        marginRight: any,
        value: any,
        date: any,
        completionPercentage: any,
        boxColor: any,
    ) => {
        if (withBorder) {
            return (
                <div className="flex  justify-content-center align-items-center " style={{
                    position: 'relative',
                    width: width,
                    height: height,
                    marginRight: marginRight
                }}>
                    <div style={{
                        position: 'absolute',
                        top: 0,
                        left: 0,
                        width: '100%',
                        height: '100%',
                        backgroundColor: borderColor,
                        clipPath: 'polygon(0% 0%, 80% 0%, 100% 50%, 80% 100%, 0% 100%, 20% 50%)',
                        zIndex: 0
                    }} />

                    <div style={{
                        position: 'absolute',
                        top: '1px',
                        left: '1px',
                        right: '1px',
                        bottom: '1px',
                        backgroundColor: color,
                        clipPath: 'polygon(0% 0%, 80% 0%, 100% 50%, 80% 100%, 0% 100%, 20% 50%)',
                        zIndex: 1
                    }} />


                    {date && <p className="m-0 ml-1" style={{
                        position: 'relative',
                        zIndex: 2,
                        fontSize: "10px",
                        color: '#E0E3EE',
                    }}>
                        {exerciseDateBody(date)}
                    </p>}
                </div>
            )
        }
        else {
            return (
                <>
                    <div className="flex flex-column justify-content-center align-items-center" style={{
                        width: width,
                        height: height,
                        backgroundColor: color,
                        clipPath: 'polygon(0% 0%, 80% 0%, 100% 50%, 80% 100%, 0% 100%, 20% 50%)',
                        marginRight: marginRight
                    }}
                    >
                        {value !== null && <p className="m-0 text-xs font-bold" style={{ color: "white" }}>{Math.round(value) + "%"}</p>}
                        {date !== null && <p
                            className={value ? "m-0" : "m-0 ml-1"}
                            style={color === "#DFE1EE"
                                ? { color: "white", fontSize: "10px" }
                                : { color: "white", fontSize: "8px" }}>
                            {exerciseDateBody(date)}
                        </p>
                        }
                        {completionPercentage !== null && <div className="flex" style={{ gap: "3px",marginBottom: "3px", alignItems: "center" }}>
                            <div style={{
                                width: "5px",
                                height: "5px",
                                minWidth: "5px",
                                minHeight: "5px",
                                maxWidth: "5px",
                                maxHeight: "5px",
                                flexShrink: 0,
                                flexGrow: 0,
                                boxSizing: "border-box",
                                display: "block",
                                backgroundColor: completionPercentage >= 0
                                    ? boxColor
                                    : "rgba(255, 255, 255, 0.75)"
                            }}></div>
                            <div style={{
                                width: "5px",
                                height: "5px",
                                minWidth: "5px",
                                minHeight: "5px",
                                maxWidth: "5px",
                                maxHeight: "5px",
                                flexShrink: 0,
                                flexGrow: 0,
                                boxSizing: "border-box",
                                display: "block",
                                backgroundColor: completionPercentage >= 33
                                    ? boxColor
                                    : "rgba(255, 255, 255, 0.75)"
                            }}></div>
                            <div style={{
                                width: "5px",
                                height: "5px",
                                minWidth: "5px",
                                minHeight: "5px",
                                maxWidth: "5px",
                                maxHeight: "5px",
                                flexShrink: 0,
                                flexGrow: 0,
                                boxSizing: "border-box",
                                display: "block",
                                backgroundColor: completionPercentage > 66
                                    ? boxColor
                                    : "rgba(255, 255, 255, 0.75)"
                            }}></div>
                        </div>}
                    </div>


                </>

            )
        }
    }

    const exercisesAdheranceListHeader = () => {
        return (
            <div className='flex justify-content-between align-items-center gap-4'>
                <p className='m-0'>{t('adheranceLast7Days')}</p>

                <div className="flex  gap-2">

                    <div className="flex flex-column justify-content-center  gap-2">
                        <p className="m-0 text-sm" style={{ whiteSpace: "nowrap" }}>{t("restDay")}</p>

                        {poligonStructure("1.6rem", "0.8rem", "#FFFFFF", false, "", "", null, null, null, null)}
                    </div>

                    <div style={{
                        height: "3rem",
                        border: "1px solid #BEC2D0"
                    }}></div>


                    <div className="flex flex-column justify-content-center gap-2">
                        <div className="flex gap-2">
                            {homePageMode === 0 && <Checkbox onChange={e => setFilterModes((prev: any) => { return { ...prev, missed: prev.missed ? 0 : 1 } })} checked={filterModes.missed === 1}></Checkbox>}
                            <p className="m-0 text-sm">{t("missed")}</p>
                        </div>

                        {poligonStructure("1.6rem", "0.8rem", "#DFE1EE", true, "#FFFFFF", "", null, null, null, null)}
                    </div>

                    <div style={{
                        height: "3rem",
                        border: "1px solid #BEC2D0"
                    }}></div>


                    <div className="flex flex-column justify-content-center gap-2">
                        <div className="flex gap-2">
                            {homePageMode === 0 && <Checkbox onChange={e => setFilterModes((prev: any) => { return { ...prev, low: prev.low ? 0 : 1 } })} checked={filterModes.low === 1}></Checkbox>}
                            <p className="m-0 text-sm">{t("low")}</p>
                        </div>

                        <div className="flex align-items-center gap-2">
                            {poligonStructure("1.6rem", "0.8rem", "#FE6E6A", true, "#FFFFFF", "", null, null, null, null)}
                            <p className="m-0 text-xs" style={{ whiteSpace: "nowrap", lineHeight: "0.1rem", color: "#727A99" }} >0-33</p>
                        </div>
                    </div>
                    <div style={{
                        height: "3rem",
                        border: "1px solid #BEC2D0"
                    }}></div>


                    <div className="flex flex-column justify-content-center gap-2">
                        <div className="flex gap-2">
                            {homePageMode === 0 && <Checkbox onChange={e => setFilterModes((prev: any) => { return { ...prev, average: prev.average ? 0 : 1 } })} checked={filterModes.average === 1}></Checkbox>}
                            <p className="m-0 text-sm">{t("average")}</p>
                        </div>

                        <div className="flex  align-items-center gap-2">
                            {poligonStructure("1.6rem", "0.8rem", "#F0CB64", true, "#FFFFFF", "", null, null, null, null)}
                            <p className="m-0 text-xs" style={{ whiteSpace: "nowrap", lineHeight: "0.1rem", color: "#727A99" }} >33-66</p>
                        </div>
                    </div>
                    <div style={{
                        height: "3rem",
                        border: "1px solid #BEC2D0"
                    }}></div>


                    <div className="flex flex-column justify-content-center gap-2">
                        <div className="flex gap-2">
                            {homePageMode === 0 && <Checkbox onChange={e => setFilterModes((prev: any) => { return { ...prev, high: prev.high ? 0 : 1 } })} checked={filterModes.high === 1}></Checkbox>}
                            <p className="m-0 text-sm">{t("high")}</p>
                        </div>

                        <div className="flex align-items-center gap-2">
                            {poligonStructure("1.6rem", "0.8rem", "#73D7AC", true, "#FFFFFF", "", null, null, null, null)}
                            <p className="m-0 text-xs" style={{ whiteSpace: "nowrap", lineHeight: "0.1rem", color: "#727A99" }} >66-100</p>
                        </div>

                    </div>
                </div>
            </div>
        )
    }


    const exercisesAdheranceListBody = (rowData: any) => {
        return (
            <div className="flex justify-content-end align-items-center">
                {
                    rowData.exercisesAdheranceList.map((exercise: any) => {
                        if (exercise.averageSuccessStatus === "Rest Day") {
                            return (
                                <>

                                    {poligonStructure("3.5rem", "2.5rem", "#FFFFFF", true, "#BEC2D0", "-0.3rem", null, exercise.exerciseDate, null, null)}

                                </>
                            )
                        }
                        if (exercise.averageSuccessStatus === "Missed") {
                            return (
                                <>
                                    {poligonStructure("3.5rem", "2.5rem", "#DFE1EE", false, "", "-0.3rem", null, exercise.exerciseDate, null, null)}
                                </>
                            )
                        }

                        if (exercise.averageSuccessStatus === "Low") {
                            const completionPercentage = exercise.numberOfExercisesCompletedPerDay / exercise.numberOfExercisesPerDay * 100;
                            return (
                                <>
                                    {poligonStructure("3.5rem", "2.5rem", "#FE6E6A", false, "", "-0.3rem", exercise.averageSuccessRate, exercise.exerciseDate, completionPercentage, "#B53633")}
                                </>
                            )
                        }
                        if (exercise.averageSuccessStatus === "Average") {
                            const completionPercentage = exercise.numberOfExercisesCompletedPerDay / exercise.numberOfExercisesPerDay * 100;
                            return (
                                <>
                                    {poligonStructure("3.5rem", "2.5rem", "#F0CB64", false, "", "-0.3rem", exercise.averageSuccessRate, exercise.exerciseDate, completionPercentage, "#BD921E")}
                                </>
                            )
                        }
                        if (exercise.averageSuccessStatus === "High") {
                            const completionPercentage = exercise.numberOfExercisesCompletedPerDay / exercise.numberOfExercisesPerDay * 100;
                            return (
                                <>
                                    {poligonStructure("3.5rem", "2.5rem", "#73D7AC", false, "", "-0.3rem", exercise.averageSuccessRate, exercise.exerciseDate, completionPercentage, "#1C935F")}

                                </>
                            )
                        }

                    })
                }
            </div>
        )

    }


    const dynamicColumns = columns.map((col: any) => {
        if (col.field === "patientFirstName") {
            return (
                <Column
                    key="patientFirstName"
                    field={col.field}
                    header={t("nameSurname")}
                    body={nameBody}
                    sortable

                />
            );
        }
        else if (col.field === "planStatus") {
            return (
                <Column
                    key="planStatus"
                    field={col.field}
                    header={t(col.field)}
                    dataType='text'
                    sortable
                />
            );
        }
        else if (col.field === "planName") {
            return (
                <Column
                    key="planName"
                    field={col.field}
                    header={t(col.field)}
                    style={{ width: '18rem' }}
                    dataType='text'
                    sortable
                />
            );
        }
        else if (col.field === "planDateStart") {
            return (
                <Column
                    key="planDateStart"
                    field={col.field}
                    header={t(col.field)}
                    body={planStartDateBody}
                    sortable
                />
            );
        }
        else if (col.field === "lastActivityDate") {
            return (
                <Column
                    key="lastActivityDate"
                    field={col.field}
                    header={t(col.field)}
                    body={lastActivityDateBody}
                    sortable
                />
            );
        }
        else if (col.field === "overallSuccess") {
            return (
                <Column
                    key="overallSuccess"
                    field={col.field}
                    header={t(col.field)}
                    body={overalSuccessBody}
                    sortable
                />
            );
        }
        else if (col.field === "adherancePercentage") {
            return (
                <Column
                    key="adherancePercentage"
                    field={col.field}
                    header={t("complition")}
                    body={complitionBody}
                    sortable
                />
            );
        }
        else if (col.field === "exercisesAdheranceList") {
            return (
                <Column
                    key="exercisesAdheranceList"
                    field={col.field}
                    header={exercisesAdheranceListHeader}
                    body={exercisesAdheranceListBody}

                />
            );
        }
    });


    return (<>
        <DataTable
            value={planList}
            paginator
            rows={25}
            totalRecords={planListCount}
            paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink JumpToPageInput RowsPerPageDropdown"
            currentPageReportTemplate={`${t("totalOf")} ${planListCount} ${t("totalOfPlan")}`}
            rowsPerPageOptions={[25, 50, 100, 200]}
            tableStyle={{ minWidth: '50rem' }}
            header={header}
            selectionMode="single"
            selection={selectedRow}
            onSelectionChange={(e) => viewPatientDetails(e.value)}
            globalFilterFields={['patientFirstName', 'patientLastName']}
            filters={filters}
        >
            {dynamicColumns}
        </DataTable>
    </>)
}

export default OngoingPlanList
